module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-14.c9ed3df6.png";